<template>
  <section class="xb-section-container">
    <h2 class="underline">RES Registration Application Pending EA Action</h2>
    <h3>Pending Submission</h3>
    <xb-statistic-card
      :data="pendingSubmissionCard"
      v-if="!isFetching"
      @click="redirectPage"
    />
    <template v-else>
      <div class="columns is-multiline">
        <div
          v-for="(item, i) in pendingSubmissionCard"
          :key="i"
          class="column xb-card-sb-wrapper is-one-third-widescreen"
        >
          <div class="media">
            <figure class="media-left">
              <p class="image is-64x64">
                <b-skeleton circle width="64px" height="64px"></b-skeleton>
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p>
                  <b-skeleton active height="20px" width="90%"></b-skeleton>
                  <b-skeleton height="20px" width="60%"></b-skeleton>
                  <b-skeleton height="20px" width="70%"></b-skeleton>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <h3>Pending Resubmission</h3>
    <xb-statistic-card
      :data="pendingResubmissionCard"
      v-if="!isFetching"
      @click="redirectPage"
    />
    <template v-else>
      <div class="columns is-multiline">
        <div
          v-for="(item, i) in pendingSubmissionCard"
          :key="i"
          class="column xb-card-sb-wrapper is-one-third-widescreen"
        >
          <div class="media">
            <figure class="media-left">
              <p class="image is-64x64">
                <b-skeleton circle width="64px" height="64px"></b-skeleton>
              </p>
            </figure>
            <div class="media-content">
              <div class="content">
                <p>
                  <b-skeleton active height="20px" width="90%"></b-skeleton>
                  <b-skeleton height="20px" width="60%"></b-skeleton>
                  <b-skeleton height="20px" width="70%"></b-skeleton>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </section>
</template>

<script>
const mapState = window.Vuex.mapState;

import baseService from "./../../../services/index";

export default {
  name: "Drafts",
  data: () => {
    return {
      isFetching: true
    };
  },
  computed: {
    ...mapState({
      apiConfig: state => state.config.configurationData,
      accessToken: state => state.auth.accessToken,
      sgID: state => state.header.userProfile.sgID,
      profileType: state => state.header.userProfile.profileType //1 for EA, 2 for RES
    }),
    headerOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.accessToken}`
        }
      };
    },
    pendingSubmissionCard() {
      return [
        {
          number: 0,
          text: "New and Returning",
          imgSrc: "/aceas/assets/common/vendor/xbase/img/icon/returning.png",
          endpoint: this.apiConfig.common_module.appManagement
            .getCountPendingSubmissionNewReturnEndpoint,
          value:
            "/RES-Management/new-and-returning?activityGroup=Pending EA Submission"
        },
        {
          number: 0,
          text: "Switching (Incoming)",
          imgSrc: "/aceas/assets/common/vendor/xbase/img/icon/process.png",
          endpoint: this.apiConfig.common_module.appManagement
            .getCountPendingSubmissionSwitchingIncomingEndpoint,
          value:
            "/RES-Management/switching/incoming-applications?activityGroup=Pending EA Submission"
        },
        {
          number: 0,
          text: "Switching (Outgoing)",
          imgSrc: "/aceas/assets/common/vendor/xbase/img/icon/process.png",
          endpoint: this.apiConfig.common_module.appManagement
            .getCountPendingEAConfirmationOutgoingEndpoint,
          value:
            "/RES-Management/switching/outgoing-applications?activityGroup=Pending%20Current%20EA%20Confirmation"
        },
        {
          number: 0,
          text: "Renewals",
          imgSrc: "/aceas/assets/common/vendor/xbase/img/icon/renewal.png",
          endpoint: this.apiConfig.common_module.appManagement
            .getCountRESRenewalEASubmission,
          value: "/RES-Management/renewal?activityGroup=Pending EA Submission"
        }
      ];
    },
    pendingResubmissionCard() {
      return [
        {
          number: 0,
          text: "New and Returning",
          imgSrc: "/aceas/assets/common/vendor/xbase/img/icon/returning.png",
          endpoint: this.apiConfig.common_module.appManagement
            .getCountPendingResubmissionNewReturnEndpoint,
          value:
            "/RES-Management/new-and-returning?activityGroup=Pending EA Resubmission"
        },
        {
          number: 0,
          text: "Switching (Incoming)",
          imgSrc: "/aceas/assets/common/vendor/xbase/img/icon/process.png",
          endpoint: this.apiConfig.common_module.appManagement
            .getCountPendingResubmissionSwitchingIncomingEndpoint,
          value:
            "/RES-Management/switching/incoming-applications?activityGroup=Pending EA Resubmission"
        },
        {
          number: 0,
          text: "Renewals",
          imgSrc: "/aceas/assets/common/vendor/xbase/img/icon/renewal.png",
          endpoint: this.apiConfig.common_module.appManagement
            .getCountRESRenewalEAResubmission,
          value: "/RES-Management/renewal?activityGroup=Pending EA Resubmission"
        }
      ];
    }
  },
  /**
   * Will be mounted for EA only so this function wont be called if profileType from parent = 1
   */
  mounted() {
    this.populateCardsNumber();
  },
  methods: {
    async populateCardsNumber() {
      for (let index = 0; index < this.pendingSubmissionCard.length; index++) {
        try {
          // To assign submission card value
          if (this.pendingSubmissionCard[index].endpoint) {
            const result = await this.fetchCountNumber(
              this.pendingSubmissionCard[index].endpoint
            );

            if (result) {
              this.assignCountSubmissionNumber(index, result);
            }
          }
        } catch (e) {
          continue;
        }
      }

      for (
        let index = 0;
        index < this.pendingResubmissionCard.length;
        index++
      ) {
        try {
          // To assign re-submission card value
          if (this.pendingResubmissionCard[index].endpoint) {
            const result = await this.fetchCountNumber(
              this.pendingResubmissionCard[index].endpoint
            );

            if (result) {
              this.assignCountResubmissionNumber(index, result);
            }
          }
        } catch (e) {
          continue;
        }
      }
      this.isFetching = false;
    },
    async fetchCountNumber(endpoint) {
      return await baseService(
        endpoint,
        {},
        () => {},
        this.handleFailed,
        this.headerOptions
      );
    },
    /**
     * PENDING SUBMISSION
     */
    assignCountSubmissionNumber(index, response) {
      this.$set(
        this.pendingSubmissionCard[index],
        "number",
        response.data.data.total
      );
    },

    /**
     * PENDING SUBMISSION
     */
    assignCountResubmissionNumber(index, response) {
      this.$set(
        this.pendingResubmissionCard[index],
        "number",
        response.data.data.total
      );
    },

    handleFailed(e) {
      return e.message;
    },

    redirectPage(value) {
      window.location.href = "/aceas" + value;
    }
  }
};
</script>

<style></style>
